import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=5551b77c&"
import script from "./Coupon.vue?vue&type=script&lang=ts&"
export * from "./Coupon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports